import { Button } from 'react-bootstrap';
import { defineMessages, useIntl } from 'react-intl';

import '../css/login.css';

import { serverURLs } from '../../common/config';
import { getEnv, getEnvAsBoolean, getResourcePath } from '../../common/utility';

const messages = defineMessages({
  sign_in_with: {
    id: 'login.sign_in_with',
    description: 'Single sign-on button label, parameterised with the provider name',
    defaultMessage: 'Sign in with {provider}',
  },
});

const OidcLoginButton: React.FC = () => {
  const { formatMessage } = useIntl();

  if (!getEnvAsBoolean('REACT_APP_OIDC_ENABLED', false)) return null;

  const providerName    = getEnv('REACT_APP_OIDC_PROVIDER_NAME', 'OpenID');
  const providerIconUrl = getEnv('REACT_APP_OIDC_PROVIDER_ICON_URL', '');

  return (
    <Button variant='outline-primary' className='oidc-button' href={serverURLs.oidc_authenticate}>
      {providerIconUrl && (
        <img src={getResourcePath(providerIconUrl)} alt='' className='oidc-button-icon' />
      )}
      {formatMessage(messages.sign_in_with, { provider: providerName })}
    </Button>
  );
};

export default OidcLoginButton;
